<template>
  <div class="father">
    <div v-if="screenWidth >= 600" class="needback">
      <!-- <div class="bannerClass"></div> -->
      <h1>{{ news.title }}</h1>
      <h4>{{ news.deputyTitle}}</h4>
      <div v-html="news.content" class="content"></div>
      <div class="right" v-if="news.source">
        来源：
        <span style="color: #576b95;">{{ news.source }}</span>
      </div>
    </div>

    <div v-else>
      <phone-news-detail />
    </div>
  </div>
</template>

<script>
import phoneNewsDetail from "./phone/phoneNewsDetail.vue";
export default {
  name: "product",
  components: { phoneNewsDetail },
  props: ["to"],
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          //console.log(this.screenWidth);
          this.timer = false;
        }, 400);
      }
    }
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      news: "",
      params: ""
    };
  },
  destroyed() {
    sessionStorage.clear();
  },
  mounted() {
    if (document.getElementById("main")) {
      document.getElementById("main").scroll(0, 0);
    }
    // var paramsData = sessionStorage.getItem("paramsData");
    //    if(paramsData){
    //         var params = JSON.parse(sessionStorage.getItem("paramsData"));
    //         this.news = params;
    //     }else{
    //         var params = this.to;
    //         sessionStorage.setItem("paramsData", this.to);
    //         this.news = JSON.parse(params);
    //     }

    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    this.params = this.$route.params.id.split(".")[0];

    this.getData();

  },
  // beforeRouteEnter (to, from, next) {
  //   next((vm) => {

  //     var paramsData = sessionStorage.getItem("paramsData");
  //      if(paramsData){
  //           var params = JSON.parse(sessionStorage.getItem("paramsData"));
  //           document.title = params.title +'【辰鳗科技集团】';
  //           document.querySelector('meta[name="description"]').setAttribute('content', params.title +'【辰鳗科技集团】')
  //       }else{
  //           var params = vm.to;
  //           sessionStorage.setItem("paramsData", vm.to);
  //           document.title = JSON.parse(params).title +'【辰鳗科技】';
  //           document.querySelector('meta[name="description"]').setAttribute('content', JSON.parse(params).title +'【辰鳗科技】')
  //       }
  //   });
  // },
  methods: {
    getData() {
      console.log(this.params)
      var params = new URLSearchParams();
      params.append("start", 1);
      params.append("limit", 1);
      params.append("aid", this.params);
      this.$axios.get("/api/websiteRecruit/getWebsiteById", {params:params}).then(res => {
        this.news = res.data.data;
        document.title = this.news.title + "【辰鳗科技集团】";
        document
          .querySelector('meta[name="description"]')
          .setAttribute("content", this.news.title + "【辰鳗科技集团】");
      });
    }
  }
};
</script>

<style scoped lang="scss">
.father{
  display: flex;
  align-items: center;
  justify-content: center;
}
.needback{
  font-size: 16px;
    width: 1000px;
    padding: 40px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(54, 97, 174, 0.1);
    border-radius: 8px;
    min-height: 230px;
    margin: 20px;

}
h1 {
  width: 880px;
  margin: 20px auto;
  white-space: wrap;
  text-align: left;
  padding-bottom: 30px;
}
h4 {
  width: 880px;
  margin: 20px auto;
  white-space: wrap;
  text-align: left;
  padding-bottom: 30px;
  font-weight: normal;
}

.right {
  text-align: right;
  width: 880px;
  margin: 20px auto 100px;
  font-size: 14px;
}
.bannerClass {
  width: 100%;
  color: #ffffff;
  height: 580px;
  background-image: url("../../assets/news/zy1.png");
  background-position: center;
  background-size: cover;
}
.content {
  text-indent: 0 !important;
  min-height: 18px;
  width: 880px;
  margin: auto;
  font-size: 18px;
  color: #0d141e;
  line-height: 1.6667;
  word-wrap: break-word;
  font-family: PingFangSC-Regular;
  text-align: justify;
  letter-spacing: 2px;
  >>> p {
    line-height: 28px;
  }

  >>> p > img {
    width: 100% !important;
    height: 50% !important;
  }
}
</style>
<style>
.ql-align-center {
  text-align: center;
}
.ql-align-left {
  text-align: right;
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=SimHei]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=SimHei]::before {
  content: "黑体";
  font-family: "SimHei";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=KaiTi]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=KaiTi]::before {
  content: "楷体";
  font-family: "KaiTi";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=FangSong]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=FangSong]::before {
  content: "仿宋";
  font-family: "FangSong";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=Arial]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=Arial]::before {
  content: "Arial";
  font-family: "Arial";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=Times-New-Roman]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=Times-New-Roman]::before {
  content: "Times New Roman";
  font-family: "Times New Roman";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=sans-serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=sans-serif]::before {
  content: "sans-serif";
  font-family: "sans-serif";
}

.ql-font-SimSun {
  font-family: "SimSun";
}

.ql-font-SimHei {
  font-family: "SimHei";
}

.ql-font-Microsoft-YaHei {
  font-family: "PangMenZhengDao";
}

.ql-font-KaiTi {
  font-family: "KaiTi";
}

.ql-font-FangSong {
  font-family: "FangSong";
}

.ql-font-Arial {
  font-family: "Arial";
}

.ql-font-Times-New-Roman {
  font-family: "Times New Roman";
}

.ql-font-sans-serif {
  font-family: "sans-serif";
}

/* 字号设置 */
/* 默认字号 */
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: "14px";
  font-size: 14px;
}

.ql-size-14px {
  font-size: 14px;
}

.ql-size-huge{
  font-size: 32px;
}

.ql-size-large{
  font-size: 18px;
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: "16px";
  font-size: 16px;
}

.ql-size-16px {
  font-size: 16px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18px";
  font-size: 18px;
}

.ql-size-18px {
  font-size: 18px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: "20px";
  font-size: 20px;
}

.ql-size-20px {
  font-size: 20px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before {
  content: "22px";
  font-size: 22px;
}

.ql-size-22px {
  font-size: 22px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="26px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="26px"]::before {
  content: "26px";
  font-size: 26px;
}

.ql-size-26px {
  font-size: 26px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
  content: "28px";
  font-size: 28px;
}

.ql-size-28px {
  font-size: 28px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
  content: "30px";
  font-size: 30px;
}

.ql-size-30px {
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/jobDetail.vue